<template>
  <nav class="w-full flex items-center justify-center bg-gray-800 p-4">
    <div class="text-2xl font-semibold font-mono">Vaccine Availability</div>
  </nav>
</template>

<script>
export default {};
</script>

<style></style>
